import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthModuleConfig } from 'angular-oauth2-oidc';
import { BehaviorSubject, from, Observable, Subject, } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AppConfigurations } from './shared/models/appConfiguration.model';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {

  private readonly CONFIG_URL = 'assets/app.config.json';
  public readonly LOADER_HIDE_HEADER = new HttpHeaders().set('loaderDisabled', 'true');
  private configuration$: BehaviorSubject<AppConfigurations> = new BehaviorSubject<AppConfigurations>({} as AppConfigurations);

  constructor(private oAuthModuleConfig: OAuthModuleConfig) {
  }

  public loadConfigurations$() {
    return from(fetch(this.CONFIG_URL).then((response) => {
      return response.json();
    })
    ).pipe(
      map( (config: AppConfigurations) => {
        this.oAuthModuleConfig.resourceServer.allowedUrls = config.authentication.allowedUrls;
        this.configuration$.next(config);
        return config;
      })
    ).toPromise();

  }

  getAppConfiguration$(): Observable<AppConfigurations> {
    return this.configuration$.asObservable().pipe(filter(v => v!== null && Object.entries(v).length > 0));
  }
}
